import React, { useState } from "react";
import PropTypes from "prop-types";
import PrintIcon from '@material-ui/icons/Print';
import GetAppIcon from '@material-ui/icons/GetApp';
import { YamazumiBarInfo, YamazumiStackedChart } from "../index"
import { Button, DialogActions, DialogContent, Grid, Typography } from "@material-ui/core";
import { multipleOperationOff, multipleOperationOn, singleOperationOff, singleOperationOn, videoModeOffColor, videoModeOffGray } from "../../../../asset";
import { singlePageStudyReport } from '../SinglePageStudyReport/SinglePageStudyReport';
import { AppPopup } from "../../..";
import YamazumiGroupedStackedChart from "../charts/YamazumiGroupedStackedChart";
import reportsCommonStyles from '../StudyBrowserReports.module.scss'
import styles from './YamazumiNebReport.module.scss'
import { utilFunctions } from "../../../../_helpers";

const YamazumiNebReport = (props) => {
    const reportBarInfoInitial = {
        open: false,
        data: []
    }
    const [reportBarInfoPopup, setReportBarInfoPopup] = useState(reportBarInfoInitial)

    const onStackBarSelect = (emp: string) => {
        const _empData = emp.split('~')
        const selectedEmployeeEPF = _empData[_empData.length - 1];
        let teamMemberRowDataIndex = 0;
        if(selectedEmployeeEPF){ //if epf found get from epf
            teamMemberRowDataIndex = props.reportData.teamMemberRawData.map(e => e.epf).indexOf(selectedEmployeeEPF);
        }else { //if epf not found get from TM #, name
            teamMemberRowDataIndex = props.reportData.teamMemberRawData.map(e => e.name).indexOf(_empData[0]);
        }
        setReportBarInfoPopup({
            open: true,
            data: props.reportData.teamMemberRawData[teamMemberRowDataIndex].formattedOperations
        })
    }

    const toggleReportBarInfoPopup = (status: boolean, data: any) => {
        setReportBarInfoPopup({
            open: status,
            data: data
        })
    }

    const onPrintClick = () => {
        const chart = document.getElementsByTagName("canvas")[0];
        singlePageStudyReport(props.reportData, chart, false);
    }

    return (
        <React.Fragment>
            <AppPopup
                scroll={'paper'}
                maxWidth="lg"
                fullWidth={true}
                open={reportBarInfoPopup.open}
                onClose={(status) => toggleReportBarInfoPopup(status, [])}
                title={"Yamazumi Employee Operations"}>
                <YamazumiBarInfo data={reportBarInfoPopup.data || []} />
            </AppPopup>
            <DialogContent>
                <Grid container className={reportsCommonStyles.nonPrintingInfoSection}>
                    <Grid container item xs={12} sm={12} md={5} lg={5} className={reportsCommonStyles.summaryInfoContainer}>
                        <Grid
                            container
                            item
                            xs={6}
                            sm={6}
                            direction="column"
                            alignItems="flex-start"
                            justify="center"
                            className={reportsCommonStyles.summaryInfoGroup}
                        >
                            <Typography>Total Elapsed Time</Typography>
                            <div>{props.reportData.totalElapsedTime?.min}<sub>MIN</sub> {props.reportData.totalElapsedTime?.sec}<sub>SEC</sub></div>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={6}
                            sm={6}
                            direction="column"
                            alignItems="flex-start"
                            justify="center"
                            className={reportsCommonStyles.summaryInfoGroup}
                        >
                            <Typography>Total Study</Typography>
                            <div>{props.reportData.categories?.length || 0}<sub>TM</sub></div>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={7} lg={7} className={reportsCommonStyles.infoContainer}>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>Module</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.module}</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>Element Mode</Grid>
                            <Grid item xs={8} className="uppercase bold">
                                {props.reportData.isElementBased ?
                                    <img src={videoModeOffColor} /> :
                                    <img src={videoModeOffGray} />}
                            </Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>Style</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.style}</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>OPERATION MODE</Grid>
                            <Grid item xs={8} className="uppercase bold">
                                {!props.reportData.isMultipleOperation ?
                                    <img src={singleOperationOn} /> :
                                    <img src={singleOperationOff} />}
                                {props.reportData.isMultipleOperation ?
                                    <img src={multipleOperationOn} /> :
                                    <img src={multipleOperationOff} />}
                            </Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>Version</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.version}</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>Total SMV</Grid>
                            <Grid item xs={8} className="uppercase bold">{utilFunctions.formatCycleTimes(props.reportData.totalSMV)}</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>PACEMAKER CT</Grid>
                            <Grid item xs={8} className="uppercase bold">{utilFunctions.formatCycleTimes(props.reportData.phaseMakerCT) || 0} SEC</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>TACT TIME</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.tactTime || 0} SEC</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>POTENTIAL PCS</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.potentialPC || 0} PCS</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>OPR.IMPROVED</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.noOfOperationImproved}</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>BALANCING LOSS</Grid>
                            <Grid item xs={8} className="uppercase bold">{utilFunctions.formatCycleTimes(props.reportData.balancingLoss)}</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>EFFICIENCY</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.moduleEfficiency}%</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>PSD</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.psd}</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>YAMAZUMI TYPE</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.yamazumiType}</Grid>
                        </Grid>
                        <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>CREATED AT</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.createdAt}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} className="mtM">
                        <div className={styles.legend}>
                            <span className={styles.tactTime}>
                                <sub></sub>
                                Tact Time
                            </span>
                            <span className={styles.pitchTime}>
                                <sub></sub>
                                Pitch Time
                            </span>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="canvasChartToPrint">
                        <YamazumiGroupedStackedChart
                            height={400}
                            legend={false}
                            datasets={props.reportData.datasets || []}
                            categories={props.reportData.categories || []}
                            tactTime={props.reportData.tactTime}
                            pitchTime={props.reportData.pitchTime}
                            onStackBarSelect={onStackBarSelect}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className="isPrintViewHidden">
                <Button
                    color="primary"
                    variant="contained"
                    onClick={onPrintClick}>
                    <PrintIcon />
                    Print Report
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => props.onDownloadReport(props.reportData)}>
                    <GetAppIcon />
                    Download
                </Button>
            </DialogActions>

        </React.Fragment>
    )
}

YamazumiNebReport.propTypes = {
    reportData: PropTypes.object.isRequired,
    onDownloadReport: PropTypes.func.isRequired,
}

export default YamazumiNebReport;
